import { mapState } from "vuex";
import { additionalConfigType, AdditionalConfigTypeEnums } from "./helper";
import { planTypes } from "@/common/constants";
import { filter, get, orderBy } from "lodash";

function getTitle($t) {
  if (additionalConfigType.configType === AdditionalConfigTypeEnums.PN_AND_TF) {
    return $t('billing.pbx.local_and_tf');
  }
  if (additionalConfigType.configType === AdditionalConfigTypeEnums.PN_ONLY) {
    return $t('billing.pbx.additional_phone_numbers');
  }
  return '';
}

function getDescription($t) {
  if (additionalConfigType.configType === AdditionalConfigTypeEnums.PN_AND_TF) {
    return $t('billing.pbx.additional_phone_numbers_config.local_and_tf_desc');
  }
  if (additionalConfigType.configType === AdditionalConfigTypeEnums.PN_ONLY) {
    return $t('billing.pbx.additional_phone_numbers_desc');
  }
  return '';
}

export default {
  key: planTypes[planTypes.ZOOM_PHONE$ADDITIONAL],
  data() {
    return {
      title: getTitle(this.$t.bind(this)),
      description: getDescription(this.$t.bind(this)),
      subtitle: '',
      productPlans: [],
      planType: planTypes.ZOOM_PHONE$ADDITIONAL,
    };
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    currentProductPlans() {
      return orderBy(
        filter(this.planMapFlat, (p) => p.type === planTypes.ZOOM_PHONE$ADDITIONAL),
        ['amount'],
        'asc',
      );
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], null);
    }
  },
  watch: {
    lowestPlan: {
      immediate: true,
      handler(v) {
        if (!v || !v.amount) {
          this.subtitle = '';
        } else {
          this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(v.amount)]);
          this.productPlans = this.currentProductPlans;
        }
      }
    }
  }
};
